export default __webpack_public_path__ + "static/media/chatapp.47e84bad.gif";